import {requestContext} from '../../../../common/requestContext';
import useTypedSelector from '../../../../common/useTypedSelector';
import {SaleState} from '../../../../graphql/generated/types';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useLogin} from '../../../../user/useLogin.hook';
import {useContentHomeOverviewQuery} from '../../../../wrapper/contentWrapper';
import {ContentHomeTabType} from '../type';

export function useGetShouldShowAnchorButton({
  seriesId,
  tabType,
}: {
  seriesId: number;
  tabType: ContentHomeTabType;
}) {
  const {isMobile} = requestContext.requestInfo.display;
  const {isLogin} = useLogin();
  const data = useContentHomeOverviewQuery({seriesId}, ONLY_DATA_CONFIG).data
    ?.contentHomeOverview;
  const lastReadProductId =
    data?.content?.serviceProperty?.pageContinue?.lastReadProductId;
  const saleState = data?.content?.saleState;

  const isCheckedBoughtOnly = useTypedSelector(
    state => state.contentHome.isCheckedBoughtOnly
  );

  return !!(
    tabType === ContentHomeTabType.product &&
    isMobile &&
    isLogin &&
    saleState === SaleState.Ing &&
    lastReadProductId &&
    !isCheckedBoughtOnly
  );
}
